(function () {
  function setOfferMode(offer, mode) {
    var duoCard = offer.querySelector('[data-offer-toggle="duo"]');
    var singleCard = offer.querySelector('[data-offer-toggle="single"]');
    var details = offer.querySelector('[data-offer-details]');
    var singleBuy = document.querySelector('[data-single-buy]');
    var isDuo = mode === 'duo';
    if (duoCard) {
      duoCard.classList.toggle('product__offer-card--active', isDuo);
      duoCard.setAttribute('aria-pressed', isDuo);
    }
    if (singleCard) {
      singleCard.classList.toggle('product__offer-card--active', !isDuo);
      singleCard.setAttribute('aria-pressed', !isDuo);
    }
    if (details) details.hidden = !isDuo;
    if (singleBuy) singleBuy.hidden = isDuo;
  }

  function updateOfferFromOption(offer, option) {
    if (!option) return;
    var image = offer.querySelector('[data-offer-second-image]');
    if (image && option.dataset.image) image.src = option.dataset.image;
    var compare = offer.querySelector('[data-offer-second-compare]');
    if (compare) compare.textContent = option.dataset.compare;
    var half = offer.querySelector('[data-offer-second-price]');
    if (half) half.textContent = option.dataset.half;
    var total = offer.querySelector('[data-offer-total]');
    if (total) total.textContent = option.dataset.total;
    var totalCompare = offer.querySelector('[data-offer-total-compare]');
    if (totalCompare) totalCompare.textContent = option.dataset.totalCompare;
    var savings = offer.querySelector('[data-offer-savings]');
    if (savings) savings.textContent = option.dataset.savings;
  }

  document.addEventListener('click', function (event) {
    var minusBtn = event.target.closest('[data-quantity-minus]');
    var plusBtn = event.target.closest('[data-quantity-plus]');
    if (minusBtn || plusBtn) {
      var wrapper = (minusBtn || plusBtn).closest('.product__quantity');
      var input = wrapper.querySelector('[data-quantity-input]');
      var value = parseInt(input.value, 10) || 1;
      value = minusBtn ? Math.max(1, value - 1) : value + 1;
      input.value = value;
      return;
    }

    var thumbnail = event.target.closest('[data-product-thumbnail]');
    if (thumbnail) {
      var gallery = thumbnail.closest('.product__gallery').querySelector('[data-product-gallery]');
      var index = parseInt(thumbnail.getAttribute('data-index'), 10) || 0;
      var slide = gallery && gallery.children[index];
      if (gallery && slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      return;
    }

    var offerToggle = event.target.closest('[data-offer-toggle]');
    if (offerToggle) {
      var offer = offerToggle.closest('[data-product-offer]');
      setOfferMode(offer, offerToggle.getAttribute('data-offer-toggle'));
      return;
    }

    var offerSubmit = event.target.closest('[data-offer-submit]');
    if (offerSubmit) {
      var offerRoot = offerSubmit.closest('[data-product-offer]');
      var select = offerRoot.querySelector('[data-offer-second-select]');
      var currentVariant = offerSubmit.getAttribute('data-current-variant');
      var secondVariant = select.value;
      if (!currentVariant || !secondVariant) return;
      offerSubmit.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            { id: currentVariant, quantity: 1 },
            { id: secondVariant, quantity: 1 },
          ],
        }),
      })
        .then(function () {
          offerSubmit.removeAttribute('aria-busy');
          if (window.NamourouCartDrawer) window.NamourouCartDrawer.refresh(true);
        })
        .catch(function () {
          offerSubmit.removeAttribute('aria-busy');
        });
      return;
    }

    var stickySubmit = event.target.closest('[data-product-sticky-submit]');
    if (stickySubmit) {
      var duoActive = document.querySelector('[data-offer-toggle="duo"].product__offer-card--active');
      if (duoActive) {
        var offerSubmitBtn = document.querySelector('[data-offer-submit]');
        if (offerSubmitBtn) offerSubmitBtn.click();
        return;
      }
      var form = document.getElementById('ProductForm');
      if (form) form.requestSubmit();
    }
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-offer-second-select]');
    if (select) {
      var offer = select.closest('[data-product-offer]');
      updateOfferFromOption(offer, select.options[select.selectedIndex]);
    }
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbnails = gallery.closest('.product__gallery').querySelectorAll('[data-product-thumbnail]');
    if (!slides.length || !thumbnails.length || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = Array.prototype.indexOf.call(slides, entry.target);
          thumbnails.forEach(function (t, i) {
            t.classList.toggle('product__thumbnail--active', i === index);
          });
        });
      },
      { root: gallery, threshold: 0.6 }
    );
    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  });

  var stickyAnchor = document.querySelector('.product__price');
  var stickyBar = document.querySelector('[data-product-sticky]');
  if (stickyAnchor && stickyBar && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        stickyBar.classList.toggle('product__sticky--show', !entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    observer.observe(stickyAnchor);
  }
})();
